import React from 'react';
import PropTypes from 'prop-types';
import styles from '../badgeBase.module.scss';
import BadgeShieldCheck from '../BadgeShieldCheck';

/**
 * Verified pill badge. Hidden when the user is Twine Recommends
 * (that badge supersedes Verified).
 */
const Verified = ({
  user,
  className = '',
  style,
  title = 'Verified',
  iconOnly = false,
  ...rest
}) => {
  if (!user || !user.verified || user.twine_recommends) {
    return null;
  }

  // Ignore legacy img-only props still passed by older call sites
  // eslint-disable-next-line no-unused-vars
  const { overrideAvatar, alt, ...spanRest } = rest;

  const classNames = [
    styles.badge,
    styles.verified,
    iconOnly ? styles.iconOnly : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classNames} style={style} title={title} {...spanRest}>
      <BadgeShieldCheck variant="verified" />
      {iconOnly ? null : <span className={styles.label}>Verified</span>}
    </span>
  );
};

Verified.propTypes = {
  user: PropTypes.shape({
    verified: PropTypes.bool,
    twine_recommends: PropTypes.bool,
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  iconOnly: PropTypes.bool,
  overrideAvatar: PropTypes.bool,
};

export default Verified;
